const textStyles = {
  "gradient-rt": {
    background: "linear-gradient(90deg, #ff478f 0%, #ff9800 100%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text",
  },
};

export default textStyles;
